import { defineMessages } from "react-intl";
const scope = "app.aiDiscoverability.reportDescription.table";
export default defineMessages({
    featuresColumnTitle: {
        id: `${scope}.featuresColumnTitle`,
        defaultMessage: "Features",
    },
    aiModelsFeatureLabel: {
        id: `${scope}.aiModelsFeatureLabel`,
        defaultMessage: "AI Models",
    },
    reportFrequencyFeatureLabel: {
        id: `${scope}.reportFrequencyFeatureLabel`,
        defaultMessage: "Report Frequency",
    },
    visibilityScoreFeatureLabel: {
        id: `${scope}.visibilityScoreFeatureLabel`,
        defaultMessage: "Visibility Score",
    },
    recurringReportsFeatureLabel: {
        id: `${scope}.recurringReportsFeatureLabel`,
        defaultMessage: "Recurring Reports",
    },
    recommendationEngineFeatureLabel: {
        id: `${scope}.recommendationEngineFeatureLabel`,
        defaultMessage: "Recommendation Engine",
    },
    geminiOnlyValue: {
        id: `${scope}.geminiOnlyValue`,
        defaultMessage: "Gemini only",
    },
    allFourModelsValue: {
        id: `${scope}.allFourModelsValue`,
        defaultMessage: "All 4 models",
    },
    basicCompetitorAnalysisValue: {
        id: `${scope}.basicCompetitorAnalysisValue`,
        defaultMessage: "Basic",
    },
    detailedCompetitorAnalysisValue: {
        id: `${scope}.detailedCompetitorAnalysisValue`,
        defaultMessage: "Detailed",
    },
    customizableReportFrequencyValue: {
        id: `${scope}.customizableReportFrequencyValue`,
        defaultMessage: "Customizable",
    },
    noneValue: {
        id: `${scope}.noneValue`,
        defaultMessage: "None",
    },
    copyAndPasteFixesValue: {
        id: `${scope}.copyAndPasteFixesValue`,
        defaultMessage: "Copy & Paste Fixes",
    },
});
